import * as React from 'react'
import ResultsChart from 'components/resultsChart'
import { Dropdown } from 'semantic-ui-react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import './styles.scss'

const questions = require('./results.' + 'fr' + '.yml')
console.log(questions)

interface Props {
    title: string,
    question: number,
    income: number,
    spendings: number,
    spent: number,
    usersValues: number[]
}

interface OfsNumbers {
    question: number,
    group: string,
    income: number,
    quintile: number,
    spendings: number,
    spent: number
}

let ofsData: OfsNumbers[] = require('./output.csv')
const groups = [
    'mean',
    'couples_with_children',
    'couples_65_more_without_children',
    'couples_65_less_without_children',
    'single_65_more',
    'single_65_less'
]

export default class Results extends React.Component<Props, any> {

    private setGroup(groupId: number) {
        // Filter the data
        let data = ofsData.filter(el => el.group === groups[groupId] && +el.question === this.props.question)
        // Add the user data
        data.push({
            'quintile': 99,
            'income': this.props.income,
            'spent': this.props.spent,
            'spendings': this.props.spendings
        })
        // Add the data to the state
        this.setState({
            data: data
        })
    }

    public componentWillMount() {
        this.setGroup(0)
    }

    public render() {
        return (
            <div>
                <div className='ui text container' style={{marginTop: '2em'}} >
                    <h4>{this.props.group} État du revenu après ce groupe de dépense selon{' '}
                    <Dropdown
                        inline
                        options={[
                            {"value": 0, "text": "moyenne"},
                            {"value": 1, "text": "couple avec des enfants"},
                            {"value": 2, "text": "couple sans enfant plus de 65 ans"},
                            {"value": 3, "text": "couple sans enfant moins de 65 ans"},
                            {"value": 4, "text": "seules plus de 65 ans"},
                            {"value": 5, "text": "seules moins de 65 ans"}
                        ]}
                        defaultValue={0}
                        onChange={(e, v) => {
                            this.setGroup(v.value)
                        }}
                    />{' '}dans les statistiques fédérales</h4>
                    <div className='legend'>
                        <div><span className='strippedLegend' />Part des <b>{this.props.title}</b> soustraite au revenu</div>
                        <div><span className='dottedLegend' />Les autres frais juqu'ici</div>
                        <div><span className='filledLegend' />Ce qu'il reste du revenu mensuel</div>
                    </div>
                    <ResultsChart data={this.state.data} />
                </div>
                <div style={{textAlign:'left'}} className='ui text container'>
                    <p className='special' dangerouslySetInnerHTML={{__html: questions[this.props.question].text}} />
                </div>
            </div>
        )
    }
}